import type { FC } from "react";
import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import CoreTrendCell from "pro-features/components/core cells/src/CoreTrendCell/CoreTrendCell";
import { FORMATTERS } from "app/common/benchmark/formatters";

import type { SearchTrafficData } from "../../types";
import CompoundWidget from "../CompoundWidget/CompoundWidget";

import { defaultEmptyDataGraph, getBarChart, getGradient } from "./graphConfig";

interface GraphWidgetProps {
    data: SearchTrafficData;
    descriptionText: string;
}

const GraphWidget: FC<GraphWidgetProps> = ({ data, descriptionText }) => {
    const { params } = useCurrentStateAndParams();
    const disabledGraph = !data?.graph?.data;

    const barChartConfig = useMemo(() => {
        const valueFormatter = (value: number | null) => FORMATTERS.numberAbbr(value);
        return getBarChart({ disabled: disabledGraph, granularity: params.timeGranularity, valueFormatter });
    }, [params.timeGranularity, disabledGraph]);

    return (
        <CompoundWidget>
            <CompoundWidget.Body
                data={data}
                descriptionText={descriptionText}
            >
                {!data?.graph?.isEmpty ? (
                    <CoreTrendCell
                        data={data?.graph ? [{ data: data.graph.data }] : [defaultEmptyDataGraph]}
                        config={barChartConfig}
                        params={getGradient({ disabled: disabledGraph })}
                    />
                ) : null}
            </CompoundWidget.Body>
        </CompoundWidget>
    );
};

export default GraphWidget;
